/* Han 22 Oct removes About reveal effects; retain theme-editor selection. */
document.addEventListener('shopify:block:select',event=>{if(event.target.closest('[data-han-story-source]'))event.target.scrollIntoView({block:'center',behavior:'instant'})});
